module.exports = __webpack_public_path__ + "static/media/ask.2a2de14f.svg";